var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showError, showSuccess } from '@spike/notifications-action';
import Axios from 'axios';
import { COMMISSIONS_ERROR_ACTION_TYPE, COMMISSIONS_FETCH_BY_STAFF_MEMBER_START_ACTION_TYPE, COMMISSIONS_FETCH_BY_STAFF_MEMBER_SUCCESS_ACTION_TYPE, COMMISSIONS_FETCH_START_ACTION_TYPE, COMMISSIONS_FETCH_SUCCESS_ACTION_TYPE, COMMISSIONS_GET_REPORT_START_ACTION_TYPE, COMMISSIONS_GET_REPORT_SUCCESS_ACTION_TYPE, COMMISSIONS_GET_START_ACTION_TYPE, COMMISSIONS_GET_SUCCESS_ACTION_TYPE, COMMISSIONS_RESET_ACTION_TYPE, COMMISSIONS_SAVE_START_ACTION_TYPE, COMMISSIONS_SAVE_SUCCESS_ACTION_TYPE, } from './CommissionsActionsTypes';
import { convertToCommissionPlan, convertToReport } from './CommissionsConverter';
var commissionsUrl = 'commission_plan';
var commissionsByStaffUrl = 'commission_plans';
var reportUrl = 'sales';
var isLastReportRequest = function (requestToken, state) { return state.commissions.requestTokens.report === requestToken; };
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var saveThunk = function (apiClientWrapper, commissionPlan) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiMethod, bodyRequest, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    url = commissionPlan.id === undefined
                        ? "".concat(commissionsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId)
                        : "".concat(commissionsUrl, "/").concat(commissionPlan.id, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    apiMethod = commissionPlan.id === undefined ? apiClientWrapper.apiClient.post : apiClientWrapper.apiClient.patch;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId,
                        staff_id: commissionPlan.staffId,
                        start_at: commissionPlan.from,
                        end_at: commissionPlan.to === null ? null : commissionPlan.to,
                        commissions_attributes: commissionPlan.commissions.map(function (commission) { return ({
                            minimum: commission.minimum,
                            maximum: commission.maximum,
                            rate: commission.rate,
                            category_id: commission.category.id,
                            cadence_id: commission.cadence.id,
                        }); }),
                    };
                    return [4 /*yield*/, apiMethod(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveSuccess(convertToCommissionPlan(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    dispatch(showSuccess('Commission Plan saved'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        console.error({ apiError: apiError_1 });
                        dispatch(error());
                        dispatch(showError('Error saving Commission Plan.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    url = "".concat(commissionsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(response.data.map(function (dto) {
                        return convertToCommissionPlan(dto, apiClientWrapper.masterData, apiClientWrapper.timeZone);
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError('Error fetching Commission Plans.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchByStaffMemberThunk = function (apiClientWrapper, staffId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchByStaffMemberStart());
                    url = "".concat(commissionsByStaffUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&staff_id=").concat(staffId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchByStaffMemberSuccess(response.data.map(function (dto) {
                        return convertToCommissionPlan(dto, apiClientWrapper.masterData, apiClientWrapper.timeZone);
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError('Error fetching by staff member Commission Plans.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getThunk = function (apiClientWrapper, commissionPlanId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    url = "".concat(commissionsUrl, "/").concat(commissionPlanId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(convertToCommissionPlan(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError('Error getting Commission Plan.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getReportThunk = function (apiClientWrapper, from, to, staffIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var dateFormat, requestToken, url, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dateFormat = 'YYYYMMDD';
                    requestToken = apiClientWrapper.uuid();
                    dispatch(getReportStart(requestToken));
                    url = "".concat(reportUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start=").concat(from.format(dateFormat), "&end=").concat(to.format(dateFormat)).concat(staffIds.length === 0 ? '' : '&staff_ids=' + staffIds.join(','));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastReportRequest(requestToken, getState()) && dispatch(getReportSuccess(convertToReport(response.data, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        dispatch(showError('Error getting Commissions Report.'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var fetchStart = function () {
    return {
        type: COMMISSIONS_FETCH_START_ACTION_TYPE,
    };
};
var fetchSuccess = function (commissionPlans) {
    return {
        type: COMMISSIONS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            commissionPlans: commissionPlans,
        },
    };
};
var fetchByStaffMemberStart = function () {
    return {
        type: COMMISSIONS_FETCH_BY_STAFF_MEMBER_START_ACTION_TYPE,
    };
};
var fetchByStaffMemberSuccess = function (commissionPlans) {
    return {
        type: COMMISSIONS_FETCH_BY_STAFF_MEMBER_SUCCESS_ACTION_TYPE,
        payload: {
            commissionPlans: commissionPlans,
        },
    };
};
var getStart = function () {
    return {
        type: COMMISSIONS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (commissionPlan) {
    return {
        type: COMMISSIONS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            commissionPlan: commissionPlan,
        },
    };
};
var saveStart = function () {
    return {
        type: COMMISSIONS_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (commissionPlan) {
    return {
        type: COMMISSIONS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            commissionPlan: commissionPlan,
        },
    };
};
var getReportStart = function (requestToken) {
    return {
        type: COMMISSIONS_GET_REPORT_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken
        }
    };
};
var getReportSuccess = function (report) {
    return {
        type: COMMISSIONS_GET_REPORT_SUCCESS_ACTION_TYPE,
        payload: {
            report: report,
        },
    };
};
var reset = function () {
    return {
        type: COMMISSIONS_RESET_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: COMMISSIONS_ERROR_ACTION_TYPE,
    };
};
